/* global google */
export const departureMarkerIcon = {
    url: '/img/departing.png',
    scaledSize: new google.maps.Size(10, 10),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(0, 0),
    alt: 'departing location icon',
}
export const arrivalMarkerIcon = {
    url: '/img/arriving.png',
    scaledSize: new google.maps.Size(10, 10),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(0, 0),
    alt: 'arriving location icon',
}
export const polylineOptions = {
    strokeOpacity: 1.0,
    strokeWeight: 5,
    clickable: true,
    geodesic: true,
}
export const polylineColors = [
    '#719EEF',
    '#DC582A',
]
export const mapOptions = {
    zoom: 14,
    disableDefaultUI: true,
    zoomControl: true,
}
export const stageTypeMarkerIcon = {
    scaledSize: new google.maps.Size(45, 45),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(20, 20),
    alt: 'stage icon',
}
export const positionMarkerIcon = {
    url: '/img/pin.png',
    scaledSize: new google.maps.Size(25, 25),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(0, 0),
    alt: 'current location icon',
}
